export const validateUserName = (value:any) => (value ? undefined : "用户名为必填");

export const validatePassword = (value:any) => (value ? undefined : "密码为必填");
